import { useContext } from 'react';
import { WorkDetailStatementSelectionContext } from '../components';

export const useStatementSelectionForWorkDetail =
    (): StatementSelectionProviderValue =>
        useContext(WorkDetailStatementSelectionContext);
